import { Provider } from 'react-redux';
import store from './redux/store';
import { Router } from './router';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default App;
